import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
	selector: 'app-generate-link-success-mssge',
	standalone: true,
	imports: [],
	templateUrl: './generate-link-success-mssge.component.html',
	styleUrl: './generate-link-success-mssge.component.scss'
})
export class GenerateLinkSuccessMssgeComponent {



	constructor(
		private dialogRef: MatDialogRef<GenerateLinkSuccessMssgeComponent>,
		private toastr: ToastrService,
		private router: Router,
		@Inject(MAT_DIALOG_DATA) public data: { url: string, fromParent: boolean }
	) { }

	closeDialog() {
		this.dialogRef.close();
	}


	copyLink() {
		navigator.clipboard.writeText(this.data.url);
		this.toastr.success('Link copied!');
	}


	goToQuizPage() {
		if (this.data?.fromParent) {
			this.closeDialog();
		} else {
			this.closeDialog();
			this.router.navigate(['admin-student-platform/admin-quiz'])
		}
	}


}